import React from 'react';
import { Flame } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';

const TrendingCard = ({ stocks, loading, onPick }) => (
  <Card data-testid="trending-card">
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Flame className="text-orange-500" size={20} />
        Trending Now
        <Badge variant="outline" className="ml-2 text-xs">Live</Badge>
      </CardTitle>
    </CardHeader>
    <CardContent>
      {loading ? (
        <p className="text-sm text-gray-500">Loading trending stocks...</p>
      ) : (
        <div className="space-y-3">
          {stocks.slice(0, 5).map((stock) => (
            <div
              key={stock.symbol}
              className="flex items-center justify-between p-3 bg-orange-50 rounded-lg hover:bg-orange-100 cursor-pointer transition-colors"
              onClick={() => onPick(stock.symbol)}
              data-testid={`trending-row-${stock.symbol}`}
            >
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-orange-600 rounded-full flex items-center justify-center text-white font-bold text-sm">
                  {stock.symbol.charAt(0)}
                </div>
                <div>
                  <p className="font-semibold text-gray-900 text-sm">{stock.symbol}</p>
                  <p className="text-xs text-gray-500">
                    Vol: {stock.volumeRatio ? `${stock.volumeRatio}x avg` : 'N/A'}
                  </p>
                </div>
              </div>
              <div className="text-right">
                <p className="font-semibold text-gray-900 text-sm">${stock.price?.toFixed(2)}</p>
                <span className={`text-xs ${stock.changePercent >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                  {stock.changePercent >= 0 ? '+' : ''}{stock.changePercent?.toFixed(2)}%
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
      <p className="text-xs text-gray-400 mt-3">
        Based on unusual volume and price momentum from Yahoo Finance
      </p>
    </CardContent>
  </Card>
);

export default TrendingCard;
